module.exports = __webpack_public_path__ + "static/img/12.d2d22e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12.jpg
// module id = 283
// module chunks = 0